var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"c-question-btn"},[_c('input',{staticClass:"check",attrs:{"type":"radio","name":_vm.id},domProps:{"checked":_vm.isActive},on:{"click":_vm.handleClick}}),_c('div',{class:`button ${_vm.color}`},[(_vm.isActive)?_c('img',{staticClass:"icon",attrs:{"src":_vm.image,"alt":""}}):_vm._e(),_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }